import React from "react";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import moment from "moment";
import { CouponType, ICoupon } from "../types";
import { getFormatter } from "../lib/format";
const formatter = getFormatter();

export interface ICouponComponentProps {
  reward: ICoupon;
}

export function CouponComponent(props: ICouponComponentProps) {
  const { reward } = props;
  return (
    <>
      <Grid item container component={"div"}>
        <Typography variant="h5" gutterBottom component={"h5"}>
          <strong>Coupon</strong>
        </Typography>
      </Grid>
      {reward.couponType === CouponType.Percentage ? (
        <Grid item container component={"div"}>
          <Typography variant="h6" component={"p"} gutterBottom>
            {reward.percentage.toFixed(2)}% Off
          </Typography>
        </Grid>
      ) : (
        <>
          {reward.percentage && reward.percentage !== 0 ? (
            <Grid item container component={"div"}>
              <Typography variant="h6" component={"p"} gutterBottom>
                {reward.percentage.toFixed(2)}% Off
              </Typography>
            </Grid>
          ) : null}
          {reward.couponAmount && reward.couponAmount !== 0 ? (
            <Grid item container component={"div"}>
              <Typography variant="h6" component={"p"} gutterBottom>
                {formatter.format(reward.couponAmount)} Off
              </Typography>
            </Grid>
          ) : null}
		{(!reward.couponAmount && reward.description) && (
            <Grid item container component={"div"}>
              <Typography variant="h6" component={"p"} gutterBottom>
                {reward.description} 
              </Typography>
            </Grid>
		)}
        </>
      )}
      {reward.restriction ? (
        <Grid item container component={"div"}>
          <Typography variant="body2" component={"p"} gutterBottom>
            <strong>Restrictions:</strong> {reward.restriction}
          </Typography>
        </Grid>
      ) : null}
      <Grid item container component={"div"}>
        <Typography component={"p"} variant="body2" gutterBottom>
          <strong>Expires: </strong> {moment(reward.couponExpires).fromNow()}
        </Typography>
      </Grid>
    </>
  );
}
